import { Observer } from 'mobx-react-lite';
import React from 'react';
import { useProps, useStore } from '../../../utils/mobx.utils';
import SearchResultList, { SearchResultType } from '../SearchResultList/SearchResultList';
import './SearchResultGrid.scss';
var SearchResultGrid = function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get searchQuery() {
            var _a;
            return (_a = p.results) === null || _a === void 0 ? void 0 : _a.form.userInput;
        },
        get pages() {
            var _a, _b;
            return (_b = (_a = p.results) === null || _a === void 0 ? void 0 : _a.pages) !== null && _b !== void 0 ? _b : [];
        },
        get services() {
            var _a, _b;
            return (_b = (_a = p.results) === null || _a === void 0 ? void 0 : _a.services) !== null && _b !== void 0 ? _b : [];
        },
        get posts() {
            var _a, _b;
            return (_b = (_a = p.results) === null || _a === void 0 ? void 0 : _a.posts) !== null && _b !== void 0 ? _b : [];
        },
        get tags() {
            var _a, _b;
            return (_b = (_a = p.results) === null || _a === void 0 ? void 0 : _a.tags) !== null && _b !== void 0 ? _b : [];
        },
    }); });
    return React.createElement(Observer, { children: function () { return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "searchResultGridWrapper" },
                React.createElement("div", { className: "searchResultGrid" },
                    React.createElement("div", { className: "wrapper" },
                        React.createElement(SearchResultList, { resultType: SearchResultType.services, resultsArray: s.services }),
                        React.createElement(SearchResultList, { resultType: SearchResultType.pages, resultsArray: s.pages }),
                        React.createElement(SearchResultList, { resultType: SearchResultType.tags, resultsArray: s.tags })),
                    React.createElement("div", { className: 'wrapper' },
                        React.createElement(SearchResultList, { resultType: SearchResultType.articles, resultsArray: s.posts })))))); } });
};
export default SearchResultGrid;
